module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b6100c9f591be6470cdfd4697de0b54.svg";